import { useEffect } from "react";
import { Col, Row } from "reactstrap";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";
import ColoredHeader from "../../../../common/AdminCommonComponents/ColoredHeading/ColoredHeader";
import InfoCard from "../../../../common/AdminCommonComponents/InfoCard/InfoCard";

const BillingAndInvoiceDetail = () => {
  const invoiceInfo = [
    { label: "Invoice ID", value: "#1234" },
    { label: "Partner name", value: "#123" },
    { label: "Billing Cycle", value: "Full Name" },
    { label: "Total Revenue", value: "03417053723" },
    { label: "Free Amount", value: "Paid" },
    { label: "Net Payable", value: "October 4, 2024" },
  ];

  const partnerDetails = [
    {
      label: "Billing Address:",
      value: "Al-Noor garden Faisalabad, Faisalabad Pakistan",
    },
    { label: "Partner name:", value: "Standard" },
    { label: "Phone no.", value: "Standard" },
    { label: "Email:", value: "shipped" },
    { label: "Payment terms:", value: "shipped" },
  ];

  const paymentInfo = [
    { label: "Payment Status:", value: "+$1.00" },
    { label: "Payment Method:", value: "-$0.00" },
    { label: "Amount Paid:", value: "+$1.00" },
    { label: "Outstanding Balance", value: "+$1.00" },
  ];

  const itemsTableData = [
    {
      productImage: "https://placehold.co/34x35?text=Maelano",
      productName: "Product name",
      productId: "#1234",
      sku: "SKU124a",
      quantity: "1",
      unitPrice: "$49.00",
      totalPrice: "$490.00",
    },
  ];

  const columns = [
    {
      name: "Product Image",
      cell: (row) => (
        <img src={row.productImage} alt="" width={34} height={35} />
      ),
    },
    { name: "Product name", selector: (row) => row.productName },
    { name: "Product ID", selector: (row) => row.productId },
    { name: "SKU", selector: (row) => row.sku },
    { name: "Qty", selector: (row) => row.quantity },
    { name: "Unit Price", selector: (row) => row.unitPrice },
    { name: "Total Price", selector: (row) => row.totalPrice },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white p-3 px-4 m-3 shadow">
      <GeneralBackButton />
      <div class="fw-semibold fs-4 text-center">Billing & Invoicing</div>

      <Row className="mt-3 row-cols-1 row-cols-sm-2 row-cols-xl-3 gy-3 gy-xl-0">
        <Col>
          <InfoCard title="Invoice Information" headerColor="#FBBD34" data={invoiceInfo} />
        </Col>
        <Col>
          <InfoCard title="Partner Details" headerColor="#41B8E4" data={partnerDetails} />
        </Col>
        <Col>
          <InfoCard title="Payment Details" headerColor="#41B8E4" data={paymentInfo} />
        </Col>
      </Row>

      <div className="shadow mt-3">
        <ColoredHeader title="Transaction Breakdown" headerColor='#9747FF' />
        <DynamicDatatable columns={columns} data={itemsTableData} type="gray" />
      </div>

      <div className="mt-3 text-end">
        <DynamicButton theme="yellow">Download Invoice</DynamicButton>
      </div>
    </div>
  );
};

export default BillingAndInvoiceDetail;